<template>
  <v-dialog v-model="dialog" persistent width="1200px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>edit</v-icon> Modificar días de reserva
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-form
        v-model="valid"
        ref="form"
        lazy-validation
      >
      <v-card-text class="px-3 py-1">
          <DatosPersonalesProgramacion
           v-if="form.id_persona"
          :id_estado_vacacion="form.id_estado_vacacion"
          v-model="total_dias_programar"
        />
        </v-card-text>
    
        <!--detalle de vacaciones programadas  -->
        <v-card-text class="px-0 py-1">
          <v-container>
            <v-flex xs12 >
                <h4><strong>Detalle papeletas registradas con los días de reserva</strong></h4>
              </v-flex>
                  <!-- Dias no programados o dias de reserva -->
      <v-card-text class="pb-0">
        <v-card
          v-if="sw_programacion"
          color="rgba(0, 92, 167, 0.699)"
          class="px-3 white--text text-xs-center text-md-left"
        >
          <v-layout row wrap>
            <v-flex xs12 md4
              ><span class="caption">DÍAS RESERVA</span><br />
              <span class="display-1" v-if="!!datos_estado_vacacion">
                {{ datos_estado_vacacion.dias_reserva }}
              </span>
            </v-flex>
            <v-flex xs12 md4
              ><span class="caption">DÍAS RESERVA SOLICITADOS</span><br />
              <span class="display-1">{{ total_dias_creados_reserva }}</span>
            </v-flex>
            <v-flex xs12 md4
              ><span class="caption">NOTA A CONSIDERAR</span><br />
              <span class="titulo">Los días de reserva se encontrarán vigentes desde el   {{ $moment(datos_programacion.fecha_corte).format("DD/MM/YYYY") }} hasta el 31/12/{{(datos_programacion.gestion)-1}}, posterior a esta fecha los días no utilizados se adicionarán al total de días no programados de vacación (según corresponde) </span>
            </v-flex>
          </v-layout>
        </v-card>
        <v-card v-else color="blue" class="px-3 white--text ">
          <span class="caption">TOTAL DÍAS NO PROGRAMADOS</span><br />
          <span class="contenido">{{ total_vacacion_disponible }}</span>
        </v-card>
      </v-card-text>
            <v-layout wrap>
              <v-flex>
                <v-data-table
                v v-if="vacaciones_detalle.length>0"
                  :items="vacaciones_detalle"
                  class="elevation-1 tabla-comprimida-light"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.nro_dias}} 
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.fecha_desde}} 
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.fecha_hasta}} 
                    </td>
                    <td class="text-xs-center">
                      {{ props.item.nro_dias}} 
                    </td>
                    <td class="text-xs-center">
                      {{
                        props.item.estado_permiso
                      }}
                    </td>
                   
                  </template>
                </v-data-table>
               
             
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-text class="px-3 py-1">
        <v-layout wrap>
            
            <v-flex xs12 md5>
              <v-text-field
                class="text-field-reducido-border"
                type="number"
                v-model="dias_reserva"
                label="Días reserva"
                outline
                clearable
               :rules="[v => v >= 0 || `Introduzca un valor mayor a 0`]"
              />
            </v-flex>
            <v-flex xs12 md1>
         
            </v-flex>
            <v-flex xs12 md5 v-if="datos_estado_vacacion && datos_estado_vacacion.dias_excedentes>0">
              * Se le informa que se añadirán {{datos_estado_vacacion && datos_estado_vacacion.dias_excedentes}} días adicionales a los días de reserva, ya que estos días podrian perderse
          </v-flex>
          </v-layout>
        </v-card-text>

        <v-card-actions class="pr-4">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="save()"
            
          >
            <v-icon>save</v-icon>
            Guardar
          </v-btn>

          <v-btn @click="close()" color="error">
            <v-icon>cancel</v-icon> {{ $t("common.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import Layout from "@/common/layout/mixins/layout";
import DatosPersonalesProgramacion from "../../vacaciones/components/DatosPersonalesProgramacion.vue";
import { parse } from "json5";

export default {
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogEditarDiasReserva", async dato => {
    this.form = dato;
    this.dias_reserva=this.form.dias_reserva;
    this.dias_reserva_antiguo=this.form.dias_reserva;
    await this.cargarPapeletas();
    await this.obtieneDatosUltimaProgramacion() ;
    await this.cargarDetalleVacaciones()
    this.dialog = true;
    });
  
  },
  data() {
    return {
      dias_reserva_antiguo:0,
      dias_reserva:0,
      datos_estado_vacacion: null,
      id_persona:null,
      detalle_gestiones_vacacion:{},
      lista_detalle_gestiones:null,
      datos_duodecima:[],
      switch_tipo_duodecima: false,
      id_tipo_duodecima: null,
      form: {},
      total_dias: 0,
      id_permi: "",
      fecha_desde: "",
      fecha_hasta: "",
      radio_data: "",
      dialog: false,
      edit: true,
      dias_saldo_para_papeletas: 0,
      loading_tabla2: false,
    
      permisos: [],
      tipo_permisos: [],
      permiso_compensacion: [],
      aux: {},
      vacaciones_detalle: [],
      dias_programados_por_gestion: 0,
      valid: false,
      loading: false,
      total_dias_programar:null,
      headers: [
      {
          text: "Nro.",
          sortable: false
        },
        {
          text: "Fecha desde",
          sortable: false
        },
        {
          text: "Fecha hasta",
          sortable: false
        },
        {
          text: "Nro. de días",
          sortable: false
        },
        {
          text: "Estado",
          sortable: false
        },
       
      ],
   
      // variables nueva funcionalidad
      dato: {},

   // Variables control programacion
   datos_programacion: null,
   l_papeletas: [],
   total_vacacion_disponible: 0,
      total_dias_solicitadas: 0,
      total_dias_no_programados: 0
    };
  },
  computed: {
    sw_programacion() {
      if (!!this.datos_programacion) {
        return (
          this.datos_programacion.gestion == new Date().getFullYear() + 1 &&
          this.$moment(this.datos_programacion.fecha_corte) <=
            this.$moment().startOf("day") &&
          this.$moment().startOf("day") <= this.$moment().endOf("year")
        );
      } else {
        return false;
      }
    },
    // Variable para calcular dias de reserva de la lista
    total_dias_creados_reserva() {
      return this.vacaciones_detalle.reduce((accumulator, current) => {
        return (
          accumulator +parseFloat(current.nro_dias)
        );
      }, 0);
    }
  },
  components: {
    DatosPersonalesProgramacion
  },
  methods: {
   
    async cargarPapeletas() {
      let res = await this.$service.graphql({
        query: `
					query{
							vPermisosPorFuncionarios(id_persona:${this.form.id_persona},gestion:${
          this.form.gestion
        },id_tipo_permiso:24){
						rows{
              id_permiso
              id_persona
              nombres
              numero
              fecha_desde
              fecha_emision
              tipo_permiso
              fecha_retorno
              estado_permiso
              nro_dias
              gestion
              hora_desde
              hora_hasta
              id_lugar
              lugar_atencion
              fecha_nac_muerte
              hora_nac_muerte
              tipo_nac_muerte
              rango_horario
              rechazo
              horas_permiso
              id_tipo_permiso
              justificacion
              jefe
              compensa_tolerancia
              permiso{
                id
                motivo
                id_tipo_permiso
                ruta_archivo
                _created_at
                tipo_permiso{
                  id
                  id_parametro_elaborado
                }
              fecha_permiso
              numero
              fecha_registro
              id_estado
              lugar
              estado{
                descripcion
                    }
                  }
						    }
					    }
						}
					`
      });
      this.l_papeletas = res.vPermisosPorFuncionarios.rows;
    },
    // Metodo para obtener la ultima gestion de programacion
    async obtieneDatosUltimaProgramacion() {
      // Obtenemos datos programacion de vacaciones si existe de la gestion siguiente
      let l_programaciones = await this.$query.select("programacion", {}, [
        "porcentaje",
        "gestion",
        "fecha_corte",
        "fecha_inicio",
        "fecha_fin",
        "fecha_ampliacion"
      ]);
      // Ordenamos la lista descendentemente para obtener el mayor
      l_programaciones.sort((a, b) => b.gestion - a.gestion);
      this.datos_programacion = l_programaciones[0];
      // OBTENEMOS DATOS DEL ESTADO VACACION
      this.datos_estado_vacacion = await this.$query.select(
        "estado_vacacion",
        {
          id_persona: this.form.id_persona,
          periodo: this.form.gestion
        },
        ["id", "dias_reserva"]
      );
      this.datos_estado_vacacion = this.datos_estado_vacacion[0];
      //obtiene dias excedentes de reserva:
      let dias_excedentes = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select vacaciones.fn_calcula_dias_excedentes_dias_reserva(${this.form.id_estado_vacacion})"){
                respuesta
                }
              }
            `
            })
            dias_excedentes =dias_excedentes.runQuery.respuesta[0].fn_calcula_dias_excedentes_dias_reserva;
            let rpt_mensaje=dias_excedentes.split("|");
          if (rpt_mensaje[0]=="1") {
            this.datos_estado_vacacion.dias_excedentes=rpt_mensaje[1]
          }else{
            this.datos_estado_vacacion.dias_excedentes=0
          }
             console.log("***",dias_excedentes)
    },

 
    //metodo para cargar el detalle de las papeletas con cargo a vacacion que fueron obtenidas para la reserva
    async cargarDetalleVacaciones() {
   try {
    this.vacaciones_detalle=[];
    let respuesta = await this.$service.graphql({
              query: `
              query{
                runQuery(consulta:"select * from vacaciones.fn_lista_papeletas_reserva_solcitadas(${parseInt(this.form.id_estado_vacacion)})"){
                respuesta
                }
              }
            `
            })

             respuesta =
              respuesta.runQuery.respuesta;
           
              this.vacaciones_detalle=respuesta;

   } catch (error) {
    console.log(error)
   }
    },

    close() {
      this.form = {};
      this.form.id_persona=null
      this.total_dias_solicitadas = 0;
      this.dialog = false;
  
      this.edit = true;
      this.$bus.$emit("closeDialogEditarDiasReserva");
    },

  
    async save() {
      try {
        // if (this.vacaciones_detalle.length>0) {
          
        // }
        if (this.dias_reserva!= parseInt(this.dias_reserva)) {
          this.$message.info("Introduzca un valor entero");
          return;
        }
        this.$confirm("Está seguro de modificar los días de reserva? Esta acción modificará tambien los días calculados para la programación", async() => {
          let rpt_mensaje;
        let user = this.$storage.get("user");
        let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select * from vacaciones.fn_modifica_dias_reserva(${parseInt(this.form.id_estado_vacacion)},${parseInt(this.dias_reserva)},${user.id})"){
                respuesta
                }
              }
            `
          });
          respuesta =respuesta.runQuery.respuesta[0].fn_modifica_dias_reserva;
          rpt_mensaje=respuesta.split("|");
          if (rpt_mensaje[0]=="1") {
            this.$message.success("Los días de reserva fuerón modificados exitosamente");
            this.close()
          }else {
            this.$message.error(rpt_mensaje[1]);
          }
        })
     
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style type="text/css" scoped>
.tituloForm {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.formato_green {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.texto {
  font-size: 1.07em;
  color: rgb(24, 106, 121);
}
.sinMargen {
  display: block !important;
  padding: 0em 0em 0em 0em !important;
  margin: 0em 0em 0em 0em !important;
  width: 100% !important;
  border-radius: 0 !important;
  line-height: 1 !important;
  min-width: 100%;
}
.tabla-gestiones {
  min-width: 100%;
  tr {
    min-width: 100%;
    text-align: center;
    th {
      height: 1em !important;
      color: rgba(2, 96, 202, 0.884);
      font-weight: bold;
      font-size: 0.9em;
      border-bottom: 1px solid rgba(2, 69, 156, 0.274);
      padding: 0px 0.2em 0px 0.2em !important;
    }
    td {
      height: 1em !important;
      font-size: 0.9em !important;
      text-align: center;
      padding: 0px 0.2em 0px 0.2em !important;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/EditarDiasReservaOtros.vue